module.exports = __webpack_public_path__ + "img/gif1.02208ffa.gif";